import type { ReactNode } from 'react'
import { ArrowLeft } from 'lucide-react'

import { Button } from '../../ui/Button'

/** The previous step of a multi-screen journey, shown above the title. */
export type PageBack = { label: string; onClick: () => void }

export function PageHeader({ eyebrow, title, description, actions, back }: { eyebrow?: string; title: string; description?: string; actions?: ReactNode; back?: PageBack | undefined }) {
  return <header className="page-header">{back && <Button type="button" className="page-back" variant="ghost" size="sm" onClick={back.onClick}><ArrowLeft size={16} strokeWidth={1.8} aria-hidden="true" />{back.label}</Button>}{eyebrow && <p className="eyebrow">{eyebrow}</p>}<div className="page-header-row"><div><h1>{title}</h1>{description && <p>{description}</p>}</div>{actions && <div className="page-actions">{actions}</div>}</div></header>
}
